<div class="login">
  <section class="section-login">
    <div class="container-fluid remove-padding">
      <div class="row g-0">
        <div
          class="
            col-md-3
            branding-bgColor
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <div class="login-images">
            <div class="logo">
              <a href="">
                <img
                  src="/assets/images/logo/logo.PNG"
                  alt="logo"
                  class="d-block mx-auto"
                />
              </a>
            </div>
            <div class="images-wrap">
              <img
                src="/assets/images/login/girls.PNG"
                alt=""
                class="img-fluid d-block mx-auto"
              />
            </div>
          </div>
        </div>
        <div class="col-md-9 d-flex justify-content-center align-items-center">
          <!-- <div class="login-info">Not a member? <a href="">Join Now</a></div> -->
          <div class="form-wrap">
            <h2 class="section-title">Sign In</h2>
            <form class="">
              <div class="form-group">
                <label for="exampleInputUserName">Username/Email Address</label>
                <input
                  type="text"
                  class="form-control rounded"
                  [(ngModel)]="email"
                  name="email"
                  id="exampleInputUserName"
                  aria-describedby="userHelp"
                  placeholder="Enter username/email address"
                />
              </div>
              <div class="form-group">
                <label for="inputPassword">Password</label>
                <input
                  type="password"
                  class="form-control rounded"
                  id="inputPassword"
                  name="password"
                  [(ngModel)]="password"
                  placeholder="Password"
                />
              </div>
              <div class="seperator text-center">
                <span>or</span>
              </div>
              <div id="recaptcha-container"></div>
              <div class="form-group">
                <label for="inputPhone">Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  [(ngModel)]="phoneNumber"
                  class="form-control rounded"
                  id="inputPhone"
                  placeholder="Phone"
                />
              </div>

              <a
                type="submit"
                class="btn btn-primary text-center w-100"
                (click)="signIn()"
              >
                Sign In
              </a>
            </form>
            <!-- <div class="forget-password text-center">
              <a>Forgot Password</a>
            </div> -->
            <!-- <div class="register-account-link text-center">
              Don’t have an account? <a href="">Signup</a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<p-dialog
  header="Enter the Confirmation code"
  [(visible)]="displayDialog"
  [style]="{ width: '400px' }"
  [baseZIndex]="10000"
>
  <div class="p-fluid p-field">
    <label for="code">Confirmation Code</label>
    <input id="code" type="text" [(ngModel)]="code" pInputText />
  </div>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (click)="verifyCode()"
      label="Verify"
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>
<div id="recaptcha-container"></div>
